export default __webpack_public_path__ + "static/media/gummycandies@2x.f5e43bfa.jpg";